




























































































































































































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import { DialogForm, Table } from '@/components/bwaff';
import _ from 'lodash';
import workspacesApi, {WorkspacesApi} from '@/views/settings/multi-user-access/workspaces/api';
import userManagerApi,{UserManagerApi} from '@/views/settings/multi-user-access/user-manager/api';

@Component({
  components: {
    DataTable: Table,
    DialogForm,
  }
})
export default class Workspaces extends Vue {
workspacesApi: WorkspacesApi = workspacesApi;
userManagerApi: UserManagerApi = userManagerApi;

rows: any = [];

addMemberMenuLoading: boolean = false;
activeWorkspace: any =  {}
allWorkspaces: any = [];
allWorkspacesNormalized: any = {};
workspacesSearch: string = '';

allMembers: any = [];
allMembersNormalized: any = {};
membersSearch: string = '';
isAddMemberMenuOpened: boolean = false;
addMemberMenuSelected: any = [];

rowsOnPage: number = 10;
pagination: any = {
  rowsPerPage: this.rowsOnPage
};

get searchedWorkspaces() {
  return this.workspacesSearch.trim()
    ? this.allWorkspaces.filter((workspace:any)=>{
      return workspace.name && workspace.name.toLowerCase()
        .includes(this.workspacesSearch.toLowerCase())
    })
    : this.allWorkspaces
}

get searchedMembers() {
  return this.membersSearch.trim()
    ? this.allMembers.filter((member:any)=>{
      return member.fullName && member.fullName.toLowerCase().includes(this.membersSearch.toLowerCase())
    })
    : this.allMembers
}

get tableRows() {
  return this.getMembersForActiveWorkspace.map((row: any) => {
    const {firstName,lastName,login,role,id,status} = row;
    return {
      name: (firstName || '') + (lastName ? ' ' + lastName : ''),
      email: login,
      role,
      status,
      id
    }
  });
}

get getTrackingDomainsForActiveWorkspace() {
  if(!this.activeWorkspace || !this.activeWorkspace.trackingDomainIds) return []
  return this.activeWorkspace.trackingDomainIds
      .map((domainId:string)=>_.get(this.$store.getters.cache.trackingDomainsObject,[domainId,'domain'],null))
      .filter((x:any)=>!!x);
}

get getMembersForActiveWorkspace() {
  if(!this.activeWorkspace) return;

  if(!this.activeWorkspace || !this.activeWorkspace.memberIds) return []
  return this.allMembers.filter((member:any)=> this.activeWorkspace.memberIds.includes(member.id))
}

get headers() {
  return [
    {
      text: this.t('Name'),
      value: 'name',
      sortable: true
    },
    {
      text: this.t('Email'),
      value: 'email',
      sortable: true
    },
    {
      text: this.t('Role'),
      value: 'role',
      sortable: true,
    },
    {
      text: '',
      value: '',
      sortable: false,
    },
  ]
}

toggleAddMemberMenu(){
  if(!this.isAddMemberMenuOpened){
    let selected:any=[];
    this.activeWorkspace.memberIds.forEach((memberId:string)=>{
      selected.push(this.allMembersNormalized[memberId])
    })
    this.addMemberMenuSelected = selected;
    this.membersSearch='';
  }
  this.isAddMemberMenuOpened = !this.isAddMemberMenuOpened;
}

get addMemberMenuIsSelectedAll(){
  return this.addMemberMenuSelected.length === this.allMembers.length
}

set addMemberMenuIsSelectedAll(value: boolean) {
  if(value){
    this.addMemberMenuSelected = this.allMembers;
  } else {
    this.addMemberMenuSelected = [];
  }
}

@Watch('workspacesApi.data')
workspacesDataReceived() {
  this.allWorkspaces = [...this.workspacesApi.data];
  this.allWorkspacesNormalized = {...this.workspacesApi.dataNormalized};
  this.setActiveWorkspace()
}

@Watch('userManagerApi.data')
membersDataReceived() {
  this.allMembers = [...this.userManagerApi.data]
  this.allMembersNormalized = {...this.userManagerApi.dataNormalized}
}

openCreateWorkspaceDialog(workspace?: any) {
  this.bus.emit('open-dialog', { name: 'CreateWorkspaceDialog', data: { workspace, setActiveWorkspace: this.setActiveWorkspace } });
}

openCreateMemberDialog(id?: any) {
  const user = this.allMembersNormalized[id]
  if(!user) return;

  this.bus.emit('open-dialog', { name: 'CreateMember', data: { user } });
}

openEditAccessPermissionsDialog(data: any) {
  this.bus.emit('open-dialog', { name: 'EditAccessPermissions', data });

}

openItemsInWorkspaceDialog(activeWorkspace: any) {
  this.bus.emit('open-dialog', { 
    name: 'ItemsInWorkspace',
    data:{
      activeWorkspace
    }
  });
}

isAllowedDelete(workspace){
  const {itemsCount,trackingDomainIds, name,memberIds} = workspace;
  if(name==='Master' || name==='Public') return false;
  return memberIds.length === 0 && trackingDomainIds.length === 0 && itemsCount === 0;
}

removeWorkspaceConfirmCall(workspace:Workspace) {
  this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
    message: this.t('Selected workspace will be deleted if you press OK.'),
    onConfirm: () => {
      this.workspacesApi.delete(workspace.id).then(() => {
        this.bus.emit('toast-success', this.t('Workspace successfully deleted'));
      }).catch((e)=>{
        const errors:string[] =e.response?.data?.errors
        if(errors){
          Object.values(errors).forEach((error:string)=>{
            this.bus.emit('toast-error', this.t(error));
          })
        }
      })
    },
  }})
}

removeUserFromWorkspaceConfirmCall(argId:string) {
  this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
    message: this.t('Do you want to remove user from workspace?'),
    onConfirm: () => {
      const memberIds = this.activeWorkspace.memberIds.filter((id:any) => id !== argId);
      this.updateWorkspace({memberIds})
    },
  }})
}

setActiveWorkspace(id?:string) {
  if(id) return this.activeWorkspace = this.allWorkspacesNormalized[id]

  if(this.activeWorkspace && this.activeWorkspace.id && this.allWorkspacesNormalized[this.activeWorkspace.id])
    return this.activeWorkspace = this.allWorkspacesNormalized[this.activeWorkspace.id]

  this.activeWorkspace = this.allWorkspaces[0]
}

saveAddMemberMenu() {
  const memberIds = this.addMemberMenuSelected.map((member:any)=>member.id);
  this.updateWorkspace({memberIds}).then(() => {
    this.toggleAddMemberMenu();
  })
}

updateWorkspace(payload:any){
  this.addMemberMenuLoading = true;
  return this.workspacesApi.put({
    ...this.activeWorkspace,
    ...payload
  }).then(() => {
    return this.userManagerApi.getMembers();
  }).then(() => {
    this.bus.emit('toast-success', this.t('Workspace successfully updated'));
  })
  .finally(() => {
    this.addMemberMenuLoading = false;
    this.userManagerApi.loading = false;
  });
}

closeBanner(){
  this.userManagerApi.patchCloseBanner()
}

}
